import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BuyerWalletService {

    constructor(private _http: HttpClient) { }

    getwalletdetails(data) {
        return this._http.post(environment.api_url+'user/mywallet',data);
    }

}
